import { type Employee } from 'src/shared/types/employee';
import { type FlexflowEmployeeDataToDisplay } from '../Contracts/types';
import { FlexflowCardStatus, type FlexflowEmployeeStatuses } from '../types';

export const getStatus = (contract: Employee | FlexflowEmployeeDataToDisplay): FlexflowEmployeeStatuses | string => {
  if ('card' in contract) {
    const flexflowContract = contract;
    if (flexflowContract.card.status === FlexflowCardStatus.TERMINATED) {
      return flexflowContract.invitationStatus;
    }
    return flexflowContract.status;
  }

  return contract.invitationStatus;
};
